// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__Hyn08","descriptions":"NotFoundBlock_descriptions__ZrubZ"};